import { Injectable, Inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  private currentLanguageSubject = new BehaviorSubject<string>('en');
  public currentLanguage$ = this.currentLanguageSubject.asObservable();

  constructor(
    @Inject('systemConfig') public SystemConfig,
    private translate: TranslateService,
  ) {
    this.initializeLanguage();
  }

  private initializeLanguage() {
    const supportedLanguages = this.SystemConfig.supportedLanguages || [
      { code: 'en', name: 'English' },
    ];

    this.translate.addLangs(supportedLanguages.map((item) => item.code));
    this.translate.setDefaultLang(supportedLanguages[0].code);

    const storedLang = localStorage.getItem('language');
    let finalLang: string;

    if (!storedLang) {
      const browserLang = this.translate.getBrowserLang();
      const supportedCodes = supportedLanguages.map((item) => item.code);
      finalLang = supportedCodes.includes(browserLang) ? browserLang : 'en';
      localStorage.setItem('language', finalLang);
    } else {
      finalLang = storedLang;
    }

    this.translate.use(finalLang);
    this.currentLanguageSubject.next(finalLang);
  }

  set language(lang: string) {
    this.translate.use(lang);
    localStorage.setItem('language', lang);
    this.currentLanguageSubject.next(lang);
  }

  get languages() {
    return (
      this.SystemConfig.supportedLanguages || [{ code: 'en', name: 'English' }]
    );
  }

  get language(): string {
    return this.currentLanguageSubject.value;
  }

  getCurrentLanguage(): Observable<string> {
    return this.currentLanguage$;
  }
}
